<template>
  <div class="content mb-5">
    <b-row>
      <b-col class="mb-3">
        <h2>{{ this.$t("Group Details") }}</h2>
      </b-col>
    </b-row>
    <b-form @submit="onSubmit" class="mb-5" v-if="!loading">
      <b-row>
        <b-col cols="12" md="6">
          <b-form-group
            id="type"
            label-for="group-name"
            :label="this.$t('Group Name')"
          >
            <b-form-input
              data-test-id="goups-group-details-group-name"
              id="group-name"
              v-model="selectedGroup.name"
              disabled
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-group label-for="description" :label="this.$t('Description')">
            <b-form-input
              id="description"
              data-test-id="goups-group-details-description"
              v-model="form.description"
              @blur="setValidationInput('description', $event.target.value)"
              v-on:keyup.enter="onSubmit"
              :state="$validateState($v.form.description)"
              :placeholder="this.$t('e.g. Marketing')"
              :disabled="fetching"
            />

            <template #invalid-feedback>
              <p v-if="!$v.form.description.required">
                {{ $t("This is a required field.") }}
              </p>
            </template>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" md="12">
          <b-form-group
            id="policy"
            :label="this.$t('Policy')"
            label-for="policy"
          >
            <t-radio-group
              v-model="form.policy"
              :loading="loading"
              :items="policyRadio"
              :dropdownOptions="policyOptions"
              :selectedItem="form.policy_id"
              :selectedItemLabel="form.policy_name"
              @change="$v.$touch()"
              @changeDropDown="onDropDownChange"
              @scrollDropDown="scrollDropDown"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <t-save-button
        data-test-id="goups-group-details-save"
        :form-model="$v.form"
        :fetching="fetching"
        @submit="onSubmit"
      />
    </b-form>

    <b-row v-if="loading" class="mb-5">
      <b-col cols="12" md="6">
        <b-skeleton animation="wave" width="85%"></b-skeleton>
        <b-skeleton animation="wave" width="55%"></b-skeleton>
        <b-skeleton animation="wave" width="70%"></b-skeleton>
      </b-col>
      <b-col cols="12" md="6">
        <b-skeleton animation="wave" width="85%"></b-skeleton>
        <b-skeleton animation="wave" width="55%"></b-skeleton>
        <b-skeleton animation="wave" width="70%"></b-skeleton>
      </b-col>
    </b-row>

    <b-row class="mb-5">
      <b-col>
        <t-data-table
          with-filter
          hoverable
          disable-row-select
          data-test-id="goups-group-details-table"
          :title="this.$t('Users')"
          :table-data="dataSet"
          :actions="tableActions"
          :loading="loading"
          :filter-placeholder="$t('Search Users')"
          user-role="customer"
          @on-export="onExport"
          @on-row-clicked="onRowClicked"
          :searchExports="searchExports"
          @export-headers="exportedHeaders"
        />
      </b-col>
    </b-row>
  </div>
</template>

<route>
{
  "name": "Customer Group"
}
</route>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  layout: "customer",
  data() {
    return {
      loading: true,
      fetching: false,
      currentHeaders: null,
      currentPage: null,
      policyOptions: [],
      previousScrollPosition: null,
      dataOptions: {
        results: 10,
        page: 1,
      },
      tableActions: {
        add: { enabled: false },
        export: { enabled: true },
        import: { enabled: false },
        delete: { enabled: false },
      },
      searchExports: ["name", "email", "description", "policyname"],
      dataSet: {
        fields: [
          { value: "name", text: "Full Name", sortable: true },
          { value: "email", text: "Email", sortable: true },
          { value: "description", text: "Description", sortable: true },
        ],
        items: [],
      },
      selected: {
        policy: null,
        status: 0,
      },
      form: {
        policy: "None",
        policy_id: null,
        policy_name: "",
        description: null,
        selectedPolicy: null,
        type: null,
        weight: null,
      },
      policyRadio: [
        {
          text: this.$t("Inherited"),
          subtitle: this.$t("Inherit default policy"),
          tooltip: this.$t("Inherit default policy"),
          testID: "group-policy-inherited",
          value: "None",
          checked: false,
          icon: "layer-backward",
          canCustomise: false,
          canDropDownSelect: false,
        },
        {
          text: this.$t("Specific"),
          subtitle: this.$t("Use a specific policy"),
          tooltip: this.$t("Use a specific"),
          testID: "group-policy-specific",
          value: "Policy",
          checked: false,
          icon: "pencil-square",
          canCustomise: false,
          canDropDownSelect: true,
        },
      ],
    };
  },
  validations: {
    form: {
      policy_id: {},
      description: {},
    },
  },
  methods: {
    ...mapActions("groups", ["fetchCustomerGroup", "updateCustomerGroup"]),
    ...mapActions("internalUsers", ["fetchInternalUserAccounts"]),
    ...mapActions("pageMeta", ["setPageTitle"]),
    ...mapActions("toast", ["displayToast"]),
    ...mapActions("customerPolicies", [
      "fetchCustomerPolicies",
      "fetchScrollCustomerPolicies",
    ]),
    setValidationInput(object, value) {
      this.form[`${object}`] = value;
      this.$v.form[`${object}`].$touch();
    },
    onRowClicked(item) {
      this.$router.push(`/customer/environment/users/${item.id}`);
    },
    onDropDownChange(item) {
      this.form.policy_id = item;
      this.$v.$touch();
    },
    scrollDropDown(item) {
      const { target } = item;
      let currentScrollPosition = target.scrollTop + target.scrollHeight;

      console.log("currentScroll", currentScrollPosition);
      console.log("previous", this.previousScrollPosition);
      console.log("currentpage", this.currentPage);
      console.log("page", this.dataOptions.page);

      if (currentScrollPosition > this.previousScrollPosition) {
        if (
          Math.ceil(target.scrollTop) >=
            target.scrollHeight - target.offsetHeight &&
          this.dataOptions.page > this.currentPage
        ) {
          try {
            this.fetchScrollCustomerPolicies({
              id: this.selectedUser.id,
              ...this.dataOptions,
            });
          } catch (e) {
            console.log("e", e);
          } finally {
            this.currentPage = this.dataOptions.page;
            this.dataOptions.page++;
          }
        }
      }
      this.previousScrollPosition = currentScrollPosition;
    },
    exportedHeaders(headers) {
      this.currentHeaders = headers;
    },
    onExport(items) {
      if (items.length) {
        const exportData = items.map((res) => {
          let payload = {};
          this.currentHeaders.forEach((headers) => {
            return (payload[headers.value] = res[headers.value]);
          });

          return payload;
        });
        this.$downloadCSV(exportData, "Groups");
      } else {
        this.displayToast({
          title: this.$t("Failure"),
          message: this.$t("No Groups in table"),
          duration: 2000,
          variant: "danger",
        });
      }
    },
    async onSubmit() {
      this.fetching = true;
      try {
        await this.updateCustomerGroup({
          id: this.selectedUser.id,
          groupId: this.selectedGroup.id,
          group: this.form,
        });
        this.displayToast({
          title: this.$t("Success"),
          message: "Updated",
          duration: 2000,
          variant: "success",
        });
      } finally {
        this.fetching = false;
        this.$v.form.$reset();
      }
    },
  },
  computed: {
    ...mapGetters("locations", ["locations", "selectedLocation"]),
    ...mapGetters("internalUsers", ["internalUsers"]),
    ...mapGetters("authentication", ["selectedUser"]),
    ...mapGetters("groups", ["selectedGroup"]),
    ...mapGetters("customerPolicies", ["customerPolicies"]),
  },
  watch: {
    selectedGroup() {
      this.form = this.selectedGroup;
      if (this.form.policy_id === null) {
        this.form.policy = "None";
      } else {
        this.form.policy = "Policy";
      }
    },
    customerPolicies() {
      this.policyOptions = [
        // { value: null, text: this.$t("None") },
        ...this.customerPolicies.map((p) => {
          return { value: p.id, text: p.name };
        }),
      ];
    },
  },
  async created() {
    await Promise.all([
      this.fetchInternalUserAccounts({
        id: this.selectedUser.id,
        groupId: this.$route.params.id,
      }),
      this.fetchCustomerGroup({
        id: this.selectedUser.id,
        groupId: this.$route.params.id,
      }),
      this.fetchCustomerPolicies({
        id: this.selectedUser.id,
        results: 10,
        sortDesc: [false],
      }),
    ]);
    this.policyOptions = [
      // { value: null, text: this.$t("None") },
      ...this.customerPolicies.map((p) => {
        return { value: p.id, text: p.name };
      }),
    ];
    this.form = this.selectedGroup;

    this.dataSet.items = this.internalUsers;
    this.setPageTitle(this.selectedGroup.name);
    this.loading = false;
  },
};
</script>

<style></style>
